import { safeStorage } from '../lib/safe-storage'
import { supabase } from '../lib/supabase'
import { nativePushNotifications } from './nativePushNotifications'
import { platform } from './platform'
import { pushNotifications } from './pushNotifications'

const PROMPT_KEY_PREFIX = 'staff_push_prompted:'

/**
 * Best-effort push onboarding after staff authentication.
 *
 * Existing permission is respected. A browser/native permission prompt is
 * attempted at most once per user on this device, while previously granted
 * users are re-synced so a current token remains associated with the account.
 */
export async function onboardStaffPushNotifications(): Promise<boolean> {
  const { data: { session } } = await supabase.auth.getSession()
  const userId = session?.user?.id
  if (!userId) return false

  const promptKey = `${PROMPT_KEY_PREFIX}${userId}`

  if (platform.isNative()) {
    if (!nativePushNotifications.isSupported()) return false
    const permission = await nativePushNotifications.getPermission()
    if (permission === 'denied') return false
    if (permission === 'default') {
      if (safeStorage.get(promptKey) === '1') return false
      safeStorage.set(promptKey, '1')
    }
    return Boolean(await nativePushNotifications.subscribe(userId))
  }

  if (!pushNotifications.isSupported()) return false
  await pushNotifications.init(userId)
  if (pushNotifications.isSubscribed()) return true

  const permission = pushNotifications.getPermission()
  if (permission === 'denied') return false
  if (permission === 'default') {
    if (safeStorage.get(promptKey) === '1') return false
    safeStorage.set(promptKey, '1')
  }

  return Boolean(await pushNotifications.subscribe(userId))
}
